import React from 'react';
import {autorun, IReactionDisposer} from 'mobx'
import {observer} from 'mobx-react'
import FormattedInput from '../base-components/FormattedInput'
import BaseBindedComponent, { BaseBindedComponentProps, BaseBindedComponentState } from '../base-components/BaseBindedComponent'
import {notEmpty} from "../../utils/validation-utils";
import ComponentOuterDiv from "./ComponentOuterDiv";
import { IDomainData, IUICurrencyColDef, IUICurrencyDef } from '../../datatypes';
import { DomainAttrInUIComponentProps } from './BaseUIComponent';

interface CurrencyProps extends BaseBindedComponentProps{
    /** @override */
    metadata:IUICurrencyColDef|IUICurrencyDef;

    /** @override */
    domainAttribute:DomainAttrInUIComponentProps;
}

interface CurrencyState extends BaseBindedComponentState {
    oldValue:string;
    value:string;
    validators: Function[];
}
class Currency extends BaseBindedComponent<CurrencyProps, CurrencyState> {
  isShowDisposer: IReactionDisposer|undefined;

  constructor(props:CurrencyProps & {[key:string]:IDomainData}) {
    super(props)

    let globalStateValue = props[props.domainAttribute!.objectName][props.domainAttribute!.name] as string;

    this.state = {
      oldValue: globalStateValue,
      value: globalStateValue,
      validators: []
    }
  }
  
  async componentDidMount() {
    super.componentDidMount();
    if(!this.props.metadata.readonly) {
      let validators = [];
      if (this.props.metadata.required) validators.push(notEmpty)

      this.setState({validators: validators})
    }
    this.isShowDisposer = autorun(() => {
      const props = this.props as CurrencyProps & {[key:string]:IDomainData};
      let globalStateValue = props[this.props.domainAttribute.objectName][this.props.domainAttribute.name] as string;

      if (this.state.value != globalStateValue && this.state.oldValue != globalStateValue){
        this.setState({value: globalStateValue, oldValue: globalStateValue})
      }
    });
  }

  componentWillUnmount() {
    this.isShowDisposer && this.isShowDisposer();
  }

  render() {
    const {metadata, domainAttribute} = this.props;
    const {
      properties,
      label,
      length,
      placeholder,
      disabled,
      readonly,
      cssClasses,
      showGroupSeparator,
      scale,
      required,
      componentId,
      autoComplete
    } = metadata;

    let width:string|undefined;
    switch(metadata.type){
        case 'CurrencyCol': width = metadata.width;
    }

    let {xs, sm, md, lg} = properties||{};
    let value = this.state.value;
    let requiredClass = required ? ' ui-currency-input-required' : ''
    let readonlyClass = readonly ? ' ui-currency-input-readonly' : ''
    let disabledClass = disabled ? ' ui-currency-input-disabled' : ''
    let className = (cssClasses ? cssClasses : '') + disabledClass + readonlyClass + requiredClass

    return (
        <ComponentOuterDiv width={width} dataGridField={!!this.props.dataGridField} xs={xs} sm={sm} md={md} lg={lg}>
          <FormattedInput
              autoComplete={autoComplete}
              label={label}
              format={"currency"}
              prefix={'$'}
              datagridfield={this.props.dataGridField}
              decimalScale = {scale}
              id={domainAttribute.namePrefix + componentId}
              hint={placeholder}
              disabled={disabled}
              showGroupSeparator={showGroupSeparator}
              required={required}
              readOnly={readonly}
              className={className}
              length={length}
              value={value}
              error={this.props.error}
              onChangeHandler={(e) => this.onChangeHandler(e, true)}
          />
        </ComponentOuterDiv>
    )
  }
}

export default observer(Currency);